module.exports = __webpack_public_path__ + "img/cadenza_allegro_dark_brown.58b85ecb.jpg";